export const COMPETITION_FEE_FIELDS = [["free", "Free"], ["freeDiscounted", "Free discounted"], ["premium", "Premium"], ["clubEntryFee", "Club entry fee"]]
export const competitionFeeCurrency = (country, key) => key === "clubEntryFee" ? country.localCurrency : country.currency
